/// <reference path="../../../ng-services/chat.service.ts"/>

import { ChatConversationMessage, Meeting } from '../../../models/chat';
import { ChatConversationService } from '../../../ng-services/chat-conversation.service';
import { MeetingsStore } from '../../../ng-services/meetings.store';
import { MeetingUtilService } from '../../../ng-services/meeting-util.service';

(function () {
    const mod = (n: number, max: number) => ((n % max) + max) % max;

    // TODO: the chat header should probably communicate with the parent component instead of depending on store
    //       to set loading view on conversation view
    class ChatConversationHeaderComponent {
        public meeting!: Meeting;

        public searchToolbarOpen: boolean = false;
        public searchResult: ChatConversationMessage[] = [];
        public searchIndex: number = 0;

        public isMeetingListOpen!: boolean;

        public isPublicChat!: boolean;

        // local value of the search term
        public searchTerm: string = '';

        // collection of observables that we need to dispose
        private _subscribes!: Rx.IDisposable[];

        static $inject = ['$timeout', 'ChatConversationService', 'MeetingsStore', 'MeetingUtilService'];

        constructor(
            private $timeout: ng.ITimeoutService,
            private conversationService: ChatConversationService,
            private meetingsStore: MeetingsStore,
            private meetingUtilService: MeetingUtilService
        ) {}

        resetState() {
            this.searchToolbarOpen = false;
            this.searchResult = [];
            this.searchIndex = 0;
            this.searchTerm = '';
        }

        $onInit() {
            this.resetState();

            this._subscribes = [
                this.conversationService.searchResult$.subscribe((searchResult) => {
                    this.$timeout(() => {
                        this.searchResult = searchResult;
                        this.firstResult();
                    });
                }),
                this.conversationService.onSearchExit$.subscribe(() => {
                    this.$timeout(() => {
                        this.resetState();
                    });
                }),
                this.meetingsStore.isMeetingListOpen$.subscribe((isMeetingListOpen) =>
                    this.$timeout(() => {
                        this.isMeetingListOpen = isMeetingListOpen;
                    })
                ),
            ];
        }

        $onChanges() {
            this.resetState();
        }

        $onDestroy() {
            this._subscribes.forEach((obs) => obs.dispose());
        }

        toggleSearch() {
            if (this.searchToolbarOpen) {
                this.conversationService.dispatchSearchMessages(this.meeting.id, '');
            } else {
                this.resetState();
                this.conversationService.dispatchExitSearch(this.meeting.id);
            }
        }

        toggleMeetingList() {
            this.meetingsStore.dispatchToggleMeetingList();
        }

        /**
         * NOTE: we need to use arrow function because <ty-filter /> changes the context of `this`.
         * @param searchTerm
         */
        onFilterChange = (searchTerm: string) => {
            this.searchTerm = searchTerm;
            this.conversationService.dispatchSearchMessages(this.meeting.id, searchTerm);
        };

        firstResult() {
            this.searchIndex = 0;
            const message = this.searchResult[this.searchIndex];
            message && this.conversationService.gotoMessage(this.meeting.id, message.id);
        }

        moveBack() {
            this.searchIndex = (this.searchIndex + 1) % this.searchResult.length; // cap max position and then go back
            const message = this.searchResult[this.searchIndex];
            message && this.conversationService.gotoMessage(this.meeting.id, message.id);
        }

        moveForward() {
            this.searchIndex = mod(this.searchIndex - 1, this.searchResult.length);
            const message = this.searchResult[this.searchIndex];
            message && this.conversationService.gotoMessage(this.meeting.id, message.id);
        }

        get meetingUrl() {
            return this.meetingUtilService.getMeetingTopicUrl(this.meeting);
        }

        get hasSearchResult() {
            return this.searchResult?.length > 0;
        }

        get searchPosition() {
            const total = this.searchResult?.length ?? 0;
            const pos = total ? this.searchIndex + 1 : 0;
            return `${pos} / ${total}`;
        }
    }

    angular.module('tradersyard').component('tyChatConversationHeader', {
        // language=HTML
        template: `
            <div class="chat_conversation_header" is-uib>
                <div class="chat_conversation_header__title">
                    <div class="btn-group btn-group-xs btn-group-equal">
                        <button class="btn btn-default toggle_conversations_button" uib-tooltip="Toggle conversations" tooltip-placement="bottom-left" ng-model="$ctrl.meetingListOpen" ng-change="$ctrl.toggleMeetingList()" uib-btn-checkbox>
                            <i ng-if="$ctrl.isMeetingListOpen" class="fa fa-chevron-up toggle_icon"></i>
                            <i ng-if="!$ctrl.isMeetingListOpen" class="fa fa-chevron-down toggle_icon"></i>
                            <i class="fa fa-users toggle_icon_mobile" ng-class="{'is-active': $ctrl.isMeetingListOpen}"></i>
                        </button>
                    </div>
                    <a ng-href="{{$ctrl.meetingUrl}}" ng-if="$ctrl.meetingUrl" target="_blank"><strong>{{$ctrl.meeting.name}}</strong></a>
                    <strong ng-if="!$ctrl.meetingUrl">{{$ctrl.meeting.name}}</strong>
                    <div class="btn-group btn-group-xs btn-group-equal" ng-if="!$ctrl.isPublicChat">
                        <button class="btn btn-default" uib-tooltip="Message history" tooltip-placement="bottom-right" ng-model="$ctrl.searchToolbarOpen" ng-change="$ctrl.toggleSearch()" uib-btn-checkbox><i class="fa fa-history"></i></button>
                    </div>
                </div>

                <div class="chat_conversation_header__search_toolbar" is-uib ng-show="$ctrl.searchToolbarOpen">
                    <ty-filter value="$ctrl.searchTerm" on-change="$ctrl.onFilterChange" debounce="300" placeholder="Search in this meeting..."/>
                    <span class="search_position">{{ $ctrl.searchPosition }}</span>
                    <div class="btn-group btn-group-xs btn-group-equal">
                        <button class="btn btn-default" ng-click="$ctrl.moveBack()" ng-disabled="!$ctrl.hasSearchResult"><i class="fa fa-arrow-up"></i></button>
                        <button class="btn btn-default" ng-click="$ctrl.moveForward()" ng-disabled="!$ctrl.hasSearchResult"><i class="fa fa-arrow-down"></i></button>
                    </div>
                </div>

            </div>
        `,
        controller: ChatConversationHeaderComponent,
        bindings: {
            meeting: '<',
            isPublicChat: '<',
        },
    });
})();
